/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { FunctionComponent } from "react";
import ThemeProvider from "./../ThemeProvider";
import styled, { css } from "styled-components";
import { generateId } from "./../_util/common.js";
// import styled from "@emotion/styled";
// import { css } from "@emotion/react";

type Props = {
  isHidden?: boolean;
  isFocusable?: boolean;
  name?: string;
  fileName: string;
  color?: string;
  title: string;
  altText?: string;
  className?: string;
  ariaLabelText?: string;
};
const contextLight = {
  main: "light",
};
const contextDark = {
  main: "dark",
};

const Icon: FunctionComponent<Props> = (props) => {
  return (
    <ThemeProvider.Consumer>
      {(context) => (
        <IconInput
          className={`${"pe-icon--" + props.fileName} ${
            props.className ? props.className : null
          }`}
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          role="img"
          alt={props.altText === undefined ? `${props.title} icon` : props.altText}
          aria-hidden={props.isHidden}
          focusable={props.isFocusable ? "true" : "false"}
          color={props.color ? props.color : null}
          context={
            context === undefined || context.main === undefined
              ? context === "light"
                ? contextLight
                : contextDark
              : context
          }
          aria-label={
            props.ariaLabelText === undefined
              ? props.title
              : `${props.title} ${props.ariaLabelText}`
          }
        >
          <title id={props.title ? `${props.title}-icon${generateId()}` : `-icon${generateId()}`}>
            {props.title}
          </title>
          <use xlinkHref={"#" + props.fileName} />
        </IconInput>
        // <h1>Icon</h1>
      )}
    </ThemeProvider.Consumer>
  );
};

const IconInput = styled.svg`
  &[class*="-18"] {
    width: 18px;
    height: 18px;
  }
  &[class*="-24"] {
    width: 24px;
    height: 24px;
  }
  & + & {
    margin-left: 16px;
  }

  ${(props) =>
    props.context.main === "light" &&
    css`
      ${(props) =>
        props.context.icon !== undefined &&
        props.context.icon.fill !== undefined &&
        css`
          fill: ${(props) =>
            props.context.icon !== undefined &&
            props.context.icon.fill !== undefined
              ? props.context.icon.fill
              : "#6a7070"};
        `}
      ${(props) =>
        props.context.icon === undefined &&
        css`
          ${(props) =>
            props.color &&
            css`
              fill: ${props.color};
            `}
        `}
    `}
  ${(props) =>
    props.context.main === "dark" &&
    css`
      ${(props) =>
        props.context.icon !== undefined &&
        props.context.icon.fill !== undefined &&
        css`
          fill: ${(props) =>
            props.context.icon !== undefined &&
            props.context.icon.fill !== undefined
              ? props.context.icon.fill
              : "#ffffff"};
        `}
      ${(props) =>
        props.context.icon === undefined &&
        css`
          ${(props) =>
            props.color &&
            css`
              fill: ${props.color};
            `}
        `}
    `}

${(props) =>
    props.context.main === undefined &&
    css`
      fill: "#6a7070";
    `}
`;

Icon.defaultProps = {
  isFocusable: false,
  isHidden: false,
  name: "",
  color: "currentColor",
};

export default Icon;
